import { render } from "./TicketRapportDetailTables.vue?vue&type=template&id=fb3f484e&ts=true"
import script from "./TicketRapportDetailTables.vue?vue&type=script&lang=ts"
export * from "./TicketRapportDetailTables.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__